<script setup lang="ts">
import type { ConfiguratorPoolSize } from '~/models/configurator/configuratorPoolSize.model'

interface Props {
  selectableSizes: ConfiguratorPoolSize[]
  shownSizes: ConfiguratorPoolSize[]
}
const props = defineProps<Props>()
const { t } = useI18n()
const currentSize = defineModel<ConfiguratorPoolSize>({
  required: true,
})

function isSelectable(size: ConfiguratorPoolSize): boolean {
  return props.selectableSizes.some(s => s.id === size.id)
}

function onSelect(size: ConfiguratorPoolSize) {
  if (isSelectable(size))
    currentSize.value = size
}

const ordenedSizes = computed(() => {
  const clonedSizes = props.selectableSizes.map(size => ({
    ...size,
  }))

  return clonedSizes.sort((a, b) => {
    const aSize = Number(a.name.toLocaleLowerCase().split(' ')[1])
    const bSize = Number(b.name.toLocaleLowerCase().split(' ')[1])
    return aSize - bSize
  })
})
</script>

<template>
  <div class="w-full flex flex-col items-center gap-2 lg:w-auto">
    <h2 class="hidden text-3xl font-bold lg:block">
      {{ t('label.size') }}
    </h2>
    <p class="mb-2 h-6 text-1.3rem">
      {{ currentSize.size }}
    </p>
    <div
      :class="{
        'flex w-full max-w-80': shownSizes.length === 1,
        'grid w-full gap-2 grid-cols-2': shownSizes.length > 1,
      }"
    >
      <AppButton
        v-for="size in ordenedSizes"
        :key="size.id"
        size="full"
        :class="{
          'opacity-50': !isSelectable(size),
        }"
        :is-disabled="!isSelectable(size)"
        :is-active="currentSize.id === size.id"
        @click="onSelect(size)"
      >
        {{ size.name }}
      </AppButton>
    </div>
  </div>
</template>
